import { jsx as _jsx } from "react/jsx-runtime";
import { useWatchForm } from "@madmedical/form";
import PreOpSurveyRow from "./PreOpSurveyRow";
const PreOpSurveyFormRow = (props) => {
    const resolvedName = `answers.${props.name}`;
    const isYes = !!useWatchForm({ name: resolvedName });
    return _jsx(PreOpSurveyRow, Object.assign({ isYes: isYes }, props));
};
export default PreOpSurveyFormRow;
